import { createApp } from './app'

const { app, router } = createApp(window.location.pathname, window.__INITIAL_STATE__)

await router.isReady()
app.mount('#app')
